/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { initialChartPage } from '../../../app/page/chart/chart.actions';
import { PageLayout } from '../common/PageLayout';
import { chartPageSelectors } from '../../../app/page/page-storage/chart/chart.selectors';
import { authSelectors } from '../../../app/auth/auth.selectors';
import { useSelect, useSelectWithParams } from '../../../utils/selector.utils';
import { DefaultChart } from './DefaultChart';
import { DEFAULT_CHART_TYPE } from '../../../app/page/chart/chart.constants';
import { pageStateSelectors } from '../../../app/page/page-state/page-state.selectors';
import Loader from 'react-loader-spinner';
import { ChartInstructions } from './ChartInstructions';
import { Breadcrumb } from '../common/Breadcrumb';
import { DEFAULT_CHART_CATEGORY_TITLE, DEFAULT_CHART_ITEM_TITLE } from '../AgencyToolsPage/DefaultChartCategory';

// Grow to fill viewport height; minHeight 0 allows nested flex children to shrink.
const fillHeight: React.CSSProperties = { flex: 1, minHeight: 0 };
const fillHeightColumn: React.CSSProperties = { ...fillHeight, display: 'flex', flexDirection: 'column' };

export const ChartPage: FunctionComponent = () => {
  const dispatch = useDispatch();

  const nodeIds = useSelect(chartPageSelectors.selectNodes);
  const showSpinner = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'chart');
  const isAdmin = useSelect(authSelectors.selectUserIsAdmin);

  useEffect(() => {
    dispatch(initialChartPage());
  }, [dispatch]);

  const hasNodes = nodeIds.length > 0;

  return (
    <PageLayout>
      <div className="row-vertical" style={fillHeight}>
        <div className="col-12" style={fillHeightColumn}>
          <div className="panel" style={{ ...fillHeightColumn, overflow: 'hidden' }}>
            <div className="no-border panel-header small-header breadcrumb-header">
              <div className="breadcrumb-header__content">
                <Breadcrumb
                  items={[
                    { name: 'Agency Tools', path: '/agency-tools' },
                    { name: DEFAULT_CHART_CATEGORY_TITLE, path: '/agency-tools' },
                    { name: DEFAULT_CHART_ITEM_TITLE },
                  ]}
                />
                <div className="breadcrumb-header__title-row">
                  <div className="flex aic">
                    <h2 className="bold mr-2">Main Chart</h2>
                    {hasNodes && <ChartInstructions />}
                  </div>
                  {isAdmin && (
                    <div className="flex aic jcr">
                      <Link to="/chart/edit" className="btn btn-md popup_button">
                        Edit
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="panel-body pt-0" style={fillHeightColumn}>
              {!showSpinner && !hasNodes && (
                <div className="flex flex-column align-center p-3">
                  <h2 className="mb-3">No organization chart has been published yet.</h2>
                </div>
              )}
              {hasNodes && !showSpinner && (
                <div style={{ ...fillHeight, minWidth: 0, position: 'relative' }}>
                  <DefaultChart nodeIds={nodeIds} chartType={DEFAULT_CHART_TYPE} readOnly />
                </div>
              )}
              {showSpinner && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                  <Loader type="TailSpin" color="var(--theme-primary-color)" height={40} width={40} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
